import { NgStyle, NgTemplateOutlet } from '@angular/common'
import { Component, TemplateRef, input } from '@angular/core'

@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  imports: [NgStyle, NgTemplateOutlet],
})
export class HeaderBarComponent {
  readonly headerTemplate = input<TemplateRef<unknown>>()
  readonly actionsTemplate = input<TemplateRef<unknown>>()
  readonly headerGradient = input<string>()
}
